/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Ornate_Capybara_AcceptInputs */

const es_shy_ornate_capybara_accept = /** @type {(inputs: Shy_Ornate_Capybara_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const gl_shy_ornate_capybara_accept = /** @type {(inputs: Shy_Ornate_Capybara_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const en_shy_ornate_capybara_accept = /** @type {(inputs: Shy_Ornate_Capybara_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

/**
* | output |
* | --- |
* | "Frequently Asked Questions" |
*
* @param {Shy_Ornate_Capybara_AcceptInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const shy_ornate_capybara_accept = /** @type {((inputs?: Shy_Ornate_Capybara_AcceptInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Ornate_Capybara_AcceptInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_shy_ornate_capybara_accept(inputs)
	if (locale === "en") return en_shy_ornate_capybara_accept(inputs)
	return es_shy_ornate_capybara_accept(inputs)
});